import { useQuery } from 'react-query';
import { AutocompleteGroup } from 'src/core/types';

import axios from './axios';

export interface useGroupAutocompleteProps {
  text?: string;
}

export function useGroupAutocomplete(props: useGroupAutocompleteProps) {
  const { text = '' } = props;

  return useQuery<Array<AutocompleteGroup>>(
    ['users-autocomplete', text],
    async () => {
      return axios
        .get<Array<AutocompleteGroup>>(
          `/posht/ashena/groups/auto-complete/?search=${text}`,
        )
        .then((res) => res.data);
    },
    {
      enabled: false,
      suspense: false,
    },
  );
}
